import {Time} from 'yougile-util'
import {SprintStickerState} from 'yougile-model'
import {DataObjectId, DataObjectProperties} from './data-object'
import {StickerType} from './sticker-constants'
import {Tag} from './tag'

export interface StickerData {
  id: DataObjectId
  type: StickerType
  title: string
  states: Tag['states']
  isSystem: boolean
  deleted: boolean
  icon: string
}

export const getStickerType = (tag?: {
  properties?: DataObjectProperties
}): StickerType => {
  return (
    (tag?.properties && (tag.properties.stickerType as StickerType)) || 'string'
  )
}

export const CustomStickersTypes = ['string', 'sprint', 'text', 'numeric']

export const stickerDataFromTag = (
  tag: Tag | undefined
): StickerData | undefined => {
  if (!tag) {
    return undefined
  }
  const type = getStickerType(tag)
  return {
    id: tag.id,
    title: tag.title,
    states: tag.states,
    type,
    isSystem: !CustomStickersTypes.includes(type),
    deleted: tag.deleted,
    icon: (tag.properties?.stickerIcon as string) ?? ''
  }
}

export const findCurrentIntervalState = (
  states: SprintStickerState[]
): SprintStickerState | undefined =>
  states.find(
    s => s.begin && s.end && Time.placementDay(Time.now(), s.begin, s.end) === 0
  )

export const oldToNewStickerColors = {
  '': 'sticker-gray',
  '#B8BFCF': 'sticker-gray',
  '#D92400': 'sticker-red',
  '#FF8C8C': 'sticker-pink',
  '#F5C24D': 'sticker-orange',
  '#79CE69': 'sticker-green',
  '#2BDBCC': 'sticker-turquoise',
  '#8CC2FF': 'sticker-blue',
  '#CA79DB': 'sticker-violet',
  'sticker-transparent': 'sticker-gray'
}

export const newToOldStickerColors = {
  'sticker-white': '',
  'sticker-gray': '#B8BFCF',
  'sticker-red': '#D92400',
  'sticker-pink': '#FF8C8C',
  'sticker-orange': '#F5C24D',
  'sticker-green': '#79CE69',
  'sticker-turquoise': '#2BDBCC',
  'sticker-blue': '#8CC2FF',
  'sticker-violet': '#CA79DB',
  'sticker-transparent': '#B8BFCF'
}

export type OldStickerColors = keyof typeof oldToNewStickerColors
export type StickerColors = keyof typeof newToOldStickerColors
